import { Filter, Interval } from '@elderbyte/ngx-starter'
import { Instant } from '@js-joda/core'
import { ControlTerminalMode } from '../../terminals/control-terminal-mode'

export class ProductionListFilterBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static readonly WORK_CENTER_ID = 'workCenterId'
  public static readonly WORK_STATION_ID = 'workStationId'
  public static readonly MODE = 'mode'
  public static readonly SCHEDULE_INTERVAL = 'scheduleInterval'
  public static readonly TIMESTAMP = 'timestamp'
  public static readonly PROD_LIST_CONF = 'prodListConfId'

  private _workCenterId: string
  private _workStationId: string

  private _mode: ControlTerminalMode

  private _scheduleInterval: Interval
  private _timestamp: Instant

  private _prodListConf: string

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static workCenterId(workCenterId: string): Filter {
    return this.start().workCenterId(workCenterId).build()[0]
  }

  public static workStationId(workStationId: string): Filter {
    return this.start().workStationId(workStationId).build()[0]
  }

  public static mode(mode: ControlTerminalMode): Filter {
    return this.start().mode(mode).build()[0]
  }

  public static scheduleInterval(scheduleInterval: Interval): Filter {
    return this.start().scheduleInterval(scheduleInterval).build()[0]
  }

  public static timestamp(timestamp: Instant): Filter {
    return this.start().timestamp(timestamp).build()[0]
  }

  public static start(): ProductionListFilterBuilder {
    return new ProductionListFilterBuilder()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public workCenterId(workCenterId: string): ProductionListFilterBuilder {
    this._workCenterId = workCenterId
    return this
  }

  public workStationId(workStationId: string): ProductionListFilterBuilder {
    this._workStationId = workStationId
    return this
  }

  public mode(mode: ControlTerminalMode): ProductionListFilterBuilder {
    this._mode = mode
    return this
  }

  public scheduleInterval(scheduleInterval: Interval): ProductionListFilterBuilder {
    this._scheduleInterval = scheduleInterval
    return this
  }

  public timestamp(timestamp: Instant): ProductionListFilterBuilder {
    this._timestamp = timestamp
    return this
  }

  public prodListConfId(prodListConfId: string): ProductionListFilterBuilder {
    this._prodListConf = prodListConfId
    return this
  }

  public build(): Filter[] {
    const filters: Filter[] = []

    if (this._workCenterId) {
      filters.push(new Filter(ProductionListFilterBuilder.WORK_CENTER_ID, this._workCenterId))
    }

    if (this._workStationId) {
      filters.push(new Filter(ProductionListFilterBuilder.WORK_STATION_ID, this._workStationId))
    }

    if (this._mode) {
      filters.push(new Filter(ProductionListFilterBuilder.MODE, this._mode))
    }

    if (this._scheduleInterval) {
      filters.push(
        new Filter(
          ProductionListFilterBuilder.SCHEDULE_INTERVAL,
          this._scheduleInterval.toInstantString()
        )
      )
    }

    if (this._timestamp) {
      filters.push(new Filter(ProductionListFilterBuilder.TIMESTAMP, this._timestamp.toString()))
    }

    if (this._prodListConf) {
      filters.push(new Filter(ProductionListFilterBuilder.PROD_LIST_CONF, this._prodListConf))
    }

    return filters
  }
}
